export default "__VITE_ASSET__CNb3FBsb__"